<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">文华财经小课堂 - 用<common-data name="appShortName_37"/>做股票量化投资</div>
        <p class="index-module_textWrap_3ygOc">通晓经济、金融、数学、计算机、心理、市场……才能做量化？开发量化策略需要复杂的编程，改个策略动辄需要重写几百行代码？写个因子需要捧起厚重的统计学教材？还得投入重金购买数据库和服务器？
        </p>
        <p class="index-module_textWrap_3ygOc">No，这些都可以不用！<common-data name="appShortName_37"/>率先推出了涵盖全流程的股票投资平台，利用平台自己写因子可以，自己不写因子也可以，利用平台丰富的因子库和研发工具包，同样也可以开发出量化策略，实现“有了<common-data name="appShortName_37"/>，自己做量化基金经理”的愿望！
        </p>
        <p class="index-module_textWrap_3ygOc">本期将介绍如何使用<common-data name="appShortName_37"/>软件全流程的策略研发平台，研发股票多因子选股策略。利用专业的策略研发工具包，提高策略整体收益。</p>
         <div class="info table2">
            <table cellpadding="7" cellspacing="0" style="width: 730px;background: #f7f9fc;text-indent:0">
                <tr class="center">
                    <th valign="top" width="18%">题目</th>
                    <th valign="top">内容</th>
                    <th valign="top" width="9%">讲师</th>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">多因子选股策略</td>
                    <td>多因子选股策略的本质是定价，是综合了市场上各类交易者不同角度的价格判断形成的定价。</td>
                    <td rowspan="7"  style="padding:0 5px;text-align:center;text-indent:0">孙健</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">全流程的策略研发平台</td>
                    <td>包括选股范围、选择因子、检验因子有效性、因子时效性参考、分析因子相关性、合成综合因子、持仓组合优化、净值优化、择时优化、生成策略分析报告、生成调仓列表这11个步骤，囊括了多因子量化研究的全过程。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">研发工具包1：<br>因子数据预处理</td>
                    <td>内置多种因子数据预处理工具，通过去极值、缺失值、标准化、中性化等手段，将因子数据对齐，建立因子排名分析基础。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">研发工具包2：<br>因子时效性参考</td>
                    <td>从动量、离散度、拥挤度三个维度考量大类因子有效性，预测因子当前的有效性周期，提供各大类因子的择时参考信息。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">研发工具包3：<br>组合优化赋权</td>
                    <td>追求收益最大化的个股权重分配工具，可在一定约束条件下，以综合因子得分最大化为目标，自动构建最优持仓组合。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">研发工具包4：<br>市场中性策略</td>
                    <td>满足机构使用股指期货构建市场中性策略的需求，且提供市值对冲、期货BETA对冲、市场性风险对冲三种对冲方式。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">文华因子库</td>
                    <td>涵盖了文华十几年的量化研究成果，长期跟踪机构研究动态，及时共享市场最前沿因子。价值类、成长类、盈利类、行为金融类等众多类别的精选因子，覆盖股票投资的各个领域。</td>
                </tr>
            </table>
        </div>
        <div  class="index-module_textWrap_3ygOc">
                讲师介绍：
        </div>
        <!-- <div>【孙健】&nbsp;文华产品经理</div> -->
            <div  class="index-module_textWrap_3ygOc">
              【孙健】  &nbsp;文华财经大客户服务部产品经理，十年来专注于客户需求整理和产品设计，每年多次在全国范围内举办和参与期货和证券领域的大型授课活动，现主要负责服务机构客户，为专业的投资者提供技术支持，解决实际使用中的问题。
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.info,
.SignUp {
    color: #646464;
    line-height: 180%;
    padding: 0 0 3px 2em;
    font-size: 14px;
}
.info table{
    border: 1px solid #d1d7d7;
    border-collapse: collapse;
}

.info_2 {
    color: #646464;
    line-height: 180%;
    padding-bottom: 3px;
}

.info table {
    width: 688px;
}

.info th {
            padding: 5px 0;

    height: 24px;
    line-height: 24px;
    background: #a4bce2;
    color: #ffffff;
    border: 1px solid #d1d7d7;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}

.info td {
    padding: 0;
     padding: 5px 8px;

    border: 1px solid #d1d7d7;
    vertical-align: middle;
    padding-left: 8px;
}

.info td.time {
    color: #002c6f;
}

.td_w,.td_b{
    line-height: 29px;
    padding: 0 0 0 22px;
    font-size: 14px;
    color: #646567;
}

.td_b{
    background: #eef0fd;
}
.table2 tr td:first-child{
    text-align: left !important;
    padding-left: 10px !important;
}
</style>